module.exports = __webpack_public_path__ + "static/img/2.94fab6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/12/2.png
// module id = FX1q
// module chunks = 2